<div class="container">
  <div class="text-container">
    <div class="title">Terms & Conditions</div>
    <p class="info-text">
      I have read, understood and agree to the T&C’s and disclaimers below for both regulatory and marketing communications
    </p>
  </div>

  <div *ngIf="tcRegulation$ | async as terms" class="tc-container">
    <div *ngFor="let term of terms.privacySettingsTermsAndConditionsDocs; let i = index" class="toggle-app">
      <dx-check-box (onValueChanged)="switchOnTnCs(term, i)"> </dx-check-box>

      <div class="toggle-title-container">
        <div (click)="download(term.fileName)" class="popi-download-text">
          {{ term.description }}
        </div>
      </div>
    </div>

    <div class="toggle-container">

    </div>
  </div>
  <button class="acceptRegulatory" (click)="acceptRegulatory()" class="accept-btn">Yes, I accept</button>
</div>
